import client from "./client";

export async function postMutator(url: string, { arg }: { arg: any }) {
  const res = await client.post(url, arg);
  return res.data;
}

export async function filePostMutator(url: string, { arg }: { arg: any }) {
  const res = await client.post(url, arg, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
}

export async function filePutMutator(url: string, { arg }: { arg: any }) {
  const res = await client.put(url, arg, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
}

export async function putMutator(url: string, { arg }: { arg: any }) {
  const res = await client.put(url, arg);
  return res.data;
}

export async function deleteMutator(url: string, { arg }: { arg: any }) {
  const res = await client.delete(url, { data: arg });
  return res.data;
}
